import { GROUP, SPADA } from '~/consts';

export default {
  data() {
    return {
      loading_get_progress: false,
      loading_get_academic: false,
      loading_get_academic_refresh: false,
      loading_get_courses: false,
      loading_get_courses_refresh: false,
      loading_get_general: false,
      loading_get_total_class: false,
      loading_get_all_class_lists: false,
      loading_get_spada_courses: false,
      loading_save_classes: false,
      allClassListsDataProvider: {
        page: {
          current: 1,
          limit: 4
        },
        criterion: [
          { criteria: 'name,class_name', operator: 'LK', value: '' },
        ]
      },
      courses: [],
      dataProviderCourses: {
        page: {
          current: 1,
          limit: 5
        },
        criterion: [
          { criteria: 'name,class_name', operator: 'LK', value: '' },
        ]
      },
      academic_classes: [],
      dataProviderAcademicClasses: {
        page: {
          current: 1,
          limit: 10,
          total: 0
        },
        criterion: [
          { criteria: 'search', operator: 'LK', value: '', custom: true },
        ]
      },
      spada_courses: [],
      progress: null,
    }
  },

  methods: {
    onGetAcademicClassesSuccess() {},
    onGetAcademicClassesFailed() {},
    getAcademicClasses(periode) {
      const vm = this;

      vm.loading_get_academic = true

      this.$axios.post(GROUP.GET_ACADEMIC_LISTS, {
        periode
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetAcademicClassesSuccess(data)
          } else {
            vm.onGetAcademicClassesFailed()
          }

          vm.loading_get_academic = false
        }).catch(() => {
          vm.onGetAcademicClassesFailed()
          vm.loading_get_academic = false
        })
    },
    onGetGeneralClassesSuccess() {},
    onGetGeneralClassesFailed() {},
    getGeneralClasses() {
      const vm = this;

      vm.loading_get_general = true

      this.$axios.post(GROUP.GET_GENERAL_LISTS)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetGeneralClassesSuccess(data)
          } else {
            vm.onGetGeneralClassesFailed()
          }

          vm.loading_get_general = false
        }).catch(() => {
          vm.onGetGeneralClassesFailed()
          vm.loading_get_general = false
        })
    },

    /**
     * Get All Class Lists
     *
     * @return void
     */
    getClassLists(refresh = false, types = ['C', 'E', 'A']) {
      const vm = this;

      if (refresh) {
        this.allClassListsDataProvider.page['current'] = 1
      }

      vm.loading_get_all_class_lists = true

      this.$axios.post(GROUP.GET_ALL_LISTS, {
        dataProvider: JSON.stringify(this.allClassListsDataProvider),
        types: types
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetClassListsSuccess(data, refresh)
          } else {
            vm.onGetClassListsFailed()
          }

          vm.loading_get_all_class_lists = false
        }).catch(() => {
          vm.onGetClassListsFailed()
          vm.loading_get_all_class_lists = false
        })
    },
    onGetClassListsSuccess() {},
    onGetClassListsFailed() {},

    onClassCopiedSuccess() {},
    onClassCopiedFailed() {},
    copyClass(id, class_ids) {
      const vm = this

      this.$axios.post(GROUP.COPY(id), {
        class_ids
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onClassCopiedSuccess(data)
          } else {
            vm.onClassCopiedFailed()
          }
        })
        .catch(() => {
          vm.onClassCopiedFailed()
        })
    },

    onGetPaginatedCoursesSuccess() {},
    onGetPaginatedCoursesFailed() {},
    getPaginatedCourses(refresh = false) {
      const vm = this;

      if (refresh) {
        this.dataProviderCourses.page['current'] = 1
        vm.loading_get_courses_refresh = true
      } else {
        vm.loading_get_courses = true
      }

      this.$axios.post(`${GROUP.GET_PAGINATED_COURSES}?with_paid_group=1`, {
        dataProvider: JSON.stringify(this.dataProviderCourses)
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            if (refresh) {
              vm.courses = data.data.data;
            } else {
              let course_ids = collect(vm.courses).pluck('id').toArray();
              let courses = collect(data.data.data).filter((g) => {
                if (course_ids.indexOf(g.id) > -1) {
                  return false;
                }

                return true;
              }).toArray();
              vm.courses = vm.courses.concat(courses);
            }

            vm.dataProviderCourses = data.data.dataProvider
            vm.onGetPaginatedCoursesSuccess(data)
          } else {
            vm.onGetPaginatedCoursesFailed()
          }

          vm.loading_get_courses_refresh = false
          vm.loading_get_courses = false
        }).catch(() => {
          vm.onGetPaginatedCoursesFailed()
          vm.loading_get_courses_refresh = false
          vm.loading_get_courses = false
        })
    },

    onGetAllPaginatedAcademicClassesSuccess() {},
    onGetAllPaginatedAcademicClassesFailed() {},
    getAllPaginatedAcademicClasses(data, refresh = false) {
      const vm = this;

      if (refresh) {
        vm.loading_get_academic_refresh = true
      } else {
        vm.loading_get_academic = true
      }

      this.$axios.post(GROUP.GET_ALL_PAGINATED_CLASSES, {
        dataProvider: JSON.stringify(this.dataProviderAcademicClasses),
        periode : data.periode,
        withsection: !this.isEmpty(data.withsection) && data.withsection ? data.withsection : false,
        withmember: !this.isEmpty(data.withmember) && data.withmember ? data.withmember : false
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.dataProviderAcademicClasses = data.data.dataProvider
            vm.onGetAllPaginatedAcademicClassesSuccess(data, refresh)
          } else {
            vm.onGetAllPaginatedAcademicClassesFailed()
          }

          vm.loading_get_academic_refresh = false
          vm.loading_get_academic = false
        }).catch(() => {
          vm.onGetAllPaginatedAcademicClassesFailed()
          vm.loading_get_academic_refresh = false
          vm.loading_get_academic = false
        })
    },

    onGetProgressSuccess() {},
    onGetProgressFailed() {},
    getProgress(id) {
      const vm = this

      if (vm.loading_get_progress) {return;}

      vm.loading_get_progress = true

      this.$axios.post(GROUP.GET_PROGRESS(id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            const progress = data.data;
            if (!this.isEmpty(progress.lastFinishedFinalTest)) {
              progress.lastFinishedFinalTest *= 1000;
            }
            if (!this.isEmpty(progress.quiz) && !this.isEmpty(progress.quiz.finishedAt) && progress.quiz.finishedAt > 0) {
              progress.quiz.finishedAt *= 1000;
            }

            vm.progress = progress
            vm.onGetProgressSuccess(data);
          } else {
            vm.onGetProgressFailed(data);
          }

          vm.loading_get_progress = false
        })
        .catch(() => {
          vm.loading_get_progress = false
        })
    },

    async getCertificate(gmid) {
      try {
        let { data } = await this.$axios.post(GROUP.GET_CERTIFICATE, {
          gmid
        });
        if (data.applicationSystem.code == 0) {
          window.open(data.data.url, '_blank');
          return data.data;
        } else {
          return null;
        }
      } catch (e) {
        return null;
      }
    },

    async generateCertificate(postdata) {
      try {
        let { data } = await this.$axios.post(GROUP.GENERATE_CERTIFICATE, {
          user_name: postdata.user_name,
          gmid: postdata.gmid,
          address: postdata.address,
          phone_number: postdata.phone_number
        });

        if (data.applicationSystem.code == 0) {
          window.open(data.data.url, '_blank');
          return data.data;
        } else {
          return null;
        }
      } catch (e) {
        return null;
      }
    },
    
    async getSpadaCourses() {
      this.loading_get_spada_courses = true

      const payload = {
        page: 1,
        isDashboard: true
      }
      
      const { data } = await this.$axios.post(SPADA.GET_COURSE, payload);
      
      this.loading_get_spada_courses = false

      if (data.applicationSystem.code == 0) {
        this.spada_courses = data.data
      } else {
        this.$buefy.toast.open({
          message: data.applicationSystem.message,
          type: 'is-danger'
        })
      }

    }
  }
}
